import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './style.css';

class IdDetail extends React.Component {
  render() {
    const { businessKyb, kyb } = this.props;
    let kybKtpImage;
    if (kyb.IMAGE_URL) {
      kybKtpImage = (
        <img src={kyb.IMAGE_URL} className={styles['img-preview']} alt="" />
      );
    } else {
      kybKtpImage = <div>-</div>;
    }
    let verifiedStatus;
    switch (businessKyb.kybStatus) {
      case 'rejected':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.rejected}`}>
            <i className="fa fa-info-circle" /> Rejected
          </span>
        );
        break;
      case 'pending':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.unverified}`}>
            <i className="fa fa-info-circle" /> Waiting for approval
          </span>
        );
        break;
      case 'approved':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.verified}`}>
            <i className="fa fa-check-circle" /> Approved
          </span>
        );
        break;
    }
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>ID {verifiedStatus}</div>
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            Name
            <div className={`pull-right ${styles['text-description']}`}>
              {kyb.KTP_NAME}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={`${styles['text-label']} ${styles['image-block']}`}>
            ID Card Photo
            <div className={`pull-right ${styles['text-description']}`}>
              {kybKtpImage}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            ID Number
            <div className={`pull-right ${styles['text-description']}`}>
              {kyb.KTP_NUMBER}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
      </div>
    );
  }
}

IdDetail.propTypes = {
  data: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
    },
  };
}

export default connect(mapStateToProps)(IdDetail);
